import React, {Component} from 'react';
import axios from 'axios';
import mapboxgl from 'mapbox-gl';
import {Competitor_research_menu} from './Competitor_menu'
import {Competitor_register} from './Competitor_register'
import {Competitor_brand} from './Competitor_brand'
import {Competitor_sidebar} from './Competitor_sidebar'
import {Competitor_financials} from './Competitor_financials';
import Competitor_demographic from './Competitor_demographic';
import {Competitor_demographic_graphs} from './Competitor_demographic_graph'
import OutsideClickHandler from 'react-outside-click-handler';
import Competitor_demographic_local from './Competitor_demographic_local'
import {Competitor_social} from './Competitor_social' 
import DemographicInfo from '../DemographicInfo';
import maptize from '../Images/maptize_logo_white-01.svg';
import turf from '@turf/area'
import State_number from './State_numbers.json'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Collapse,
    IconButton,
    Chip
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
// import { urlencoded } from 'body-parser';
import {ReactComponent as Search} from '../Layer_images/Settings_images/search.svg';
import ReactDOMServer from 'react-dom/server';
import { CompetitorTopPerformers } from './Competitor_top_performers';
import {CompetitorMarketSegmentation} from './Competitor_market_segmentation'
import {CompetitorProductOverview} from './CompetitorProductOverview'
import {CompetitorDealsOverview} from './CompetitorDealsOverview'
import {CompetitorSearchBar} from './CompetitorSearchBar'
import MapboxDraw from "@mapbox/mapbox-gl-draw";

const CompetitorPopup = ({ data }) => {
    const formatNumber = (num, divisor = 1) => {
      if (!num) return '0';
      return (num / divisor).toLocaleString();
    };

    console.log('data: ', data)

    return (
      <div className="p-15">
        <div className="popup-item">
          <strong>Est. Foot Traffic:</strong> {data.footTraffic ? `${formatNumber(data.footTraffic)}` : "No Data"}
        </div>
        <div className="popup-item">
          <strong>Ranking:</strong> {data.ranking ? data.ranking : "No Data"}
        </div>
        {/* <div className="popup-item">
          <strong>Est. Revenue:</strong> {data.Est_revenue ? `$${formatNumber(data.Est_revenue, 1000)}` : "No Data"}
        </div> */}
        <div className="popup-item">
          <strong>Est. Lease:</strong> {data.lease ? `$${formatNumber(data.lease)}` : "No Data"}
        </div>
        <div className="popup-item">
          <strong>Est. Location Value:</strong> {data.locationValue ? `$${formatNumber(data.locationValue)}` : "No Data"}
        </div>
        <div className="popup-item">
          <strong>Employee Cost:</strong> {data.Employee_cost ? `$${formatNumber(data.Employee_cost)}` : "No Data"}
        </div>
      </div>
    );
  };
var drawtooltip = false;
export class Competitor_search extends React.Component{
    constructor(props) {
        super(props);
        this.state= {
            search_competitor: "",
            competitor: [],
            searched: [],
            brandLocal: false,
            products: [],
            deals: [],
            markers: [],
            map: null,
            expandedPanel: 'panel1', // For accordion control
            expandedRows: {} // For product table rows
        }
    }
    gettier = async () =>{
        let token = localStorage.getItem("auth-token");
        if(token === "" || !token ) return null;
        try{
            let response = await axios.post('/signup/freetier/type', {}, {headers:{ "auth-token": token}})
            let res = await response.data
            if(res.freetier == null) return;
            this.setState({freetier: res.freetier})
        }catch(e){
            console.log(e)
        }
    }
    componentDidMount(){
        this.gettier()
    }
    competitor_search = async (e) =>{
        let search_competitor = e.target.value 
        this.setState({search_competitor, search_result_show: true})
        var search_res = await axios.post('/gettheurl/competitorapi', {search: search_competitor}, );
        let search = await search_res.data;
        this.setState({searched: search})
        
    }
    search_num(num, Est_revenue, avg_revenue){
        if(num > 0) Est_revenue += (avg_revenue * num)
        return Est_revenue
    }
    regionselected(regionfilter){
        if(!regionfilter) return;

        var regionfilterzoom;
        if(regionfilter.type === "MultiPolygon"){ 
            function indexOfMax(arr) {
                if (arr.length === 0) {
                    return -1;
                } var max = arr[0]; var maxIndex = 0;
                for (var i = 1; i < arr.length; i++) {
                    if (arr[i] > max) {maxIndex = i;max = arr[i];}} return maxIndex;}

            console.log(regionfilter.coordinates)
            let regionsizes = regionfilter.coordinates.map((coor) => turf({type: "Polygon", coordinates: coor}))
            console.log(regionsizes, indexOfMax(regionsizes), "regionssize")
            regionfilterzoom = regionfilter.coordinates[indexOfMax(regionsizes)][0]
        }else{
            regionfilterzoom = regionfilter.coordinates[0];
        } 
        var bounds = regionfilterzoom.reduce(function (bounds, coord) {
            return bounds.extend(coord);
        }, new mapboxgl.LngLatBounds(regionfilterzoom[0], regionfilterzoom[0]));
        
        this.state.map.fitBounds(bounds, {
            padding: 20
        });
        console.log(regionfilter, 'regionfilter')
        
        // Function to add region layer
        const addRegionLayer = () => {
            if (this.state.map.getSource('region')) {
                this.state.map.removeLayer('region');
                this.state.map.removeSource('region');
            }
            this.state.map.addSource('region', {
                'type': 'geojson',
                'data': {
                'type': 'Feature',
                'geometry': regionfilter
                }})
            this.state.map.addLayer({
                    'id': 'region',
                    'type': 'fill',
                    'source': "region",
                    'layout': {},
                    'paint': {
                    'fill-color': '#396BF0',
                    'fill-opacity': .1,
                    }
            });
        };

        // Check if style is loaded before adding layers
        if (this.state.map.isStyleLoaded()) {
            addRegionLayer();
        } else {
            this.state.map.once('styledata', addRegionLayer);
        }
    }

    loadImageIntoMap = (imageName, imageUrl) => {
        return new Promise((resolve, reject) => {
            this.state.map.loadImage(imageUrl, (error, image) => {
                if (error) {
                    reject(error);
                } else {
                    this.state.map.addImage(imageName, image);
                    resolve();
                }
            });
        });
    }

    addPlaceLayer = (geojson, regionfilter, brandLogo={}) => {
        // Function to add places layer
        const addPlacesLayer = () => {
            if (this.state.map.getSource('places')) {
                this.state.map.removeLayer('places');
                this.state.map.removeSource('places');
            }
        
            this.state.map.addSource('places', {
                'type': 'geojson',
                'data': {
                    'type': 'FeatureCollection',
                    'features': geojson
                }
            });

            // Building match expression for dynamically setting the icon image
            let matchExpression = ['match', ['get', 'brand']];
            let iconSizeMatchExpression = ['match', ['get', 'brand']];
            if (Object.keys(brandLogo).length === 0) {
                brandLogo['Dummy'] = 'default-icon';
            }

            Object.keys(brandLogo).forEach(brand => {
                matchExpression.push(brand, brand);
                iconSizeMatchExpression.push(brand, 0.5);
            });
            matchExpression.push('marker-11'); 
            iconSizeMatchExpression.push(1.5);

            this.state.map.addLayer({
                'id': 'places',
                'type': 'symbol',
                'source': 'places',
                'layout': {
                    'icon-image': matchExpression,
                    'icon-size': iconSizeMatchExpression,
                    'icon-allow-overlap': true
                }
            });

            this.setupMapInteractions();
        };

        // console.log(geojson, regionfilter, 'geojson');
        
        this.regionselected(regionfilter);

        // Check if style is loaded before adding layers
        if (this.state.map.isStyleLoaded()) {
            addPlacesLayer();
        } else {
            this.state.map.once('styledata', addPlacesLayer);
        }
    }
    createPopupDataFromFeature = (properties) => ({
        title: properties.title,
        Est_revenue: properties.rev,
        lease: properties.Lease * 15,
        locationValue: properties.Location,
        Employee_cost: properties.Employee
      });

    handlePlacesClick = (e) => {
        const coordinates = e.features[0].geometry.coordinates.slice();
        const feature = e.features[0];
        console.log('feature: ', e.features)

        new mapboxgl.Popup()
          .setLngLat(coordinates)
          .setHTML(this.createReactPopup(feature.properties))
          .addTo(this.state.map);
    };
    
    setupMapInteractions = () => {
        this.state.map.on('mouseenter', 'places', () => {
            this.state.map.getCanvas().style.cursor = 'pointer';
        });
        this.state.map.on('mouseleave', 'places', () => {
            this.state.map.getCanvas().style.cursor = '';
        });
        this.state.map.on('click', 'places', (e) => {
            this.handlePlacesClick(e)
        });
    }
    


    showposition = (geojson, regionfilter) => {
        
        console.log('regionfilter: ', regionfilter);
        
        if (geojson) {
            // Only add layer if map already existed (not newly created)
            this.addPlaceLayer(geojson, regionfilter);
            
            // Clean up existing markers
            if (this.state.markers && this.state.markers.length > 0) {
                this.state.markers.forEach(marker => marker.remove());
            }
            
            this.setState({ places: true, markers: [] });
        } else {
            // Clean up places layer if it exists
            if (this.state.map && this.state.map.getSource('places')) {
                this.state.map.removeLayer('places');
                this.state.map.removeSource('places');
            }
            
            this.regionselected(regionfilter);
            
            // Clean up markers
            if (this.state.markers && this.state.markers.length > 0) {
                this.state.markers.forEach(marker => marker.remove());
            }
            
            this.setState({ markers: [] });
        }
    }
    numberWithCommasPopUp(x, number) {
        if(!x) return "No Data"
        x = Math.round(x * number)
        return "$"+ x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }


    searchvalue = async (search, region, geometry) => {
        const temp_search = window.location.href.split('?')[0];
        window.history.pushState({}, null, `${temp_search}?search=${encodeURI(search)}`);
    
        const token = localStorage.getItem("auth-token");
        if (search === "") return null;
    
        document.body.style.overflow = "hidden";
        
        if (region && region.State) {
            const stateEntry = Object.entries(State_number).find(([_, value]) => value.ABR === region.State);
            if (stateEntry) region.State = stateEntry[0];
        }

        const customBoundary = geometry ? true : false;
        if(!geometry && this.state.draw){
            const allFeatures = this.state.draw.getAll();
            if (allFeatures.features.length > 0) {
                allFeatures.features.forEach(feature => {
                        this.state.draw.delete(feature.id);
                });
            }
        }
        this.setState({
            searched: [], 
            search_result_show: false, 
            search_competitor: search, 
            customBoundary,
            loading: true
        });
    
        try {
            const product_list = await axios.post('/gettheurl/product-overview', {name: search}, {headers: {"auth-token": token}});
            const product_data = await product_list.data;
    
            this.setState({products: product_data.products, deals: product_data.deals || [], website: product_data.website})
    
            const response = await axios.post('/gettheurl/competitorsearch', {search, region, geometry}, {headers: {"auth-token": token}});
            const res = await response.data;
            console.log('res: ', res)
    
            if (res.nullResult) {
                
                return this.setState({error: 'No Results found', loading: false});
            }else{
                this.setState({error: null});
            }
    
            if (res.brandLocal) {
                return this.handleBrandLocalResponse(res);
            }
    
            if (res.freetier) {
                return this.handleFreeTierResponse(res);
            }
    
            return this.handleFullResponse(res);
        } catch (error) {
            this.handleSearchError(error);
        } finally {
            document.body.style.overflow = "visible";
        }
    }
    
    handleBrandLocalResponse = (res) =>  {
        const { business_data, brand, cat_all, brandLogo } = res;
        
        const aggregatedData = business_data.reduce((acc, data) => {
            if (data.data_circle) {
                acc.expense += data.data_circle.expenses2018.mortgage;
                acc.population += data.data_circle.total_age_sex.pop_2018_f;
                acc.income += data.data_circle.family_estincome.estincome_2018;
                acc.number++;
            }
            if(data.revenue){
                acc.revenue += parseInt(data.revenue) || 0; 
                acc.revenueNumber += 1;
            }
            if(data.lease){
                acc.lease += parseInt(data.lease) || 0; 
                acc.leaseNumber += 1;
            }
            if(data.lease){
                acc.operationExpense += parseInt(data.expense) || 0; 
                acc.operationExpenseNumber += 1;
            }
            
            return acc;
        }, { number: 0, revenueNumber: 0, operationExpenseNumber: 0, leaseNumber: 0, expense: 0, population: 0, income: 0, revenue: 0, lease: 0, operationExpense: 0 });
    
        const avgIncome = Math.round(aggregatedData.income / aggregatedData.number);
        const avgExpense = Math.round(aggregatedData.expense / aggregatedData.number);
        const operationExpenseNumber = aggregatedData.operationExpenseNumber || 1 ;
        const revenueNumber = aggregatedData.revenueNumber || 1;
        const leaseNumber = aggregatedData.leaseNumber  || 1;
        const avgExpenseOperation = Math.round(aggregatedData.operationExpense / operationExpenseNumber);
        const avgRevenue = Math.round(aggregatedData.revenue / revenueNumber);
        const avgLease = Math.round(aggregatedData.lease / leaseNumber);
        // console.log('aggregatedData.revenue: ', aggregatedData.revenue)
        const geojson = business_data.map(e => ({geometry: {type: 'Point', coordinates: e.coordinates}, properties: {title: e.name, rev: e.rev, brand: e.brand}}));
        this.showposition()
        if(this.state.markers.length > 0) this.state.markers.map((marker) => marker.remove())
        this.setState({places: true, markers: []})
        
        if(!this.state.imagesLoaded){
            // Collect all promises for image loading
            var logoPromises = Object.entries(brandLogo).map(([brand, logoUrl]) =>
                this.loadImageIntoMap(brand, logoUrl)
            );
            this.setState({imagesLoaded: true})
            // Wait for all logos to load before adding the source and layers
            Promise.all(logoPromises).then(() => {
                this.addPlaceLayer(geojson, res.geometry, brandLogo)
            });
        }else{
            this.addPlaceLayer(geojson, res.geometry, brandLogo)
        }


        this.setState({
            loading: false,
            brand,
            search: res.search,
            business_data,
            brandLocal: true,
            expense: avgExpense,
            income: avgIncome,
            population: aggregatedData.population,
            Est_revenue: Math.round(aggregatedData.revenue / 1000),
            bl_cost: aggregatedData.lease,
            Employee_cost_avg: avgExpenseOperation,
            Employee_cost: aggregatedData.operationExpense,
            avg_revenue: Math.round(avgRevenue / 1000),
            bl_cost_avg: avgLease,
            type: brand.type,
            upgradereq: false,
            social_data: brand.social_data,

        });
    }
    
    handleFreeTierResponse = (res) => {
        const { brand, num_revenue, Est_revenue, avg_revenue, population } = res;
        const num = parseInt(brand.final_locations) - num_revenue;
        const updatedEstRevenue = this.search_num(num, Est_revenue, avg_revenue);
    
        this.setState({
            loading: false,
            brand,
            search: res.search,
            num_population: res.num_population,
            Est_revenue: updatedEstRevenue,
            avg_revenue,
            population,
            freetier: true
        });
    }




// Helper functions
 initializeCounters = () => ({
  population: 0,
  expense: 0,
  income: 0,
  counts: [0, 0, 0, 0, 0, 0], // [revenue, population, lease, employee, expense, income]
  totals: {
    Est_revenue: 0,
    Employee_cost: 0,
    bl_cost: 0
  },
  demographics: {
    race: [0, 0, 0, 0, 0], // [White, Black, Hispanic, Asian, American Indian]
    age: new Array(14).fill(0),
    degree: new Array(7).fill(0),
    gender: [0, 0] // [male, female]
  }
});

extractCoordinates = (geometry) => {
  if (!geometry) return null;
  
  const { coordinates, type } = geometry;
  
  switch (type) {
    case "Polygon":
      return coordinates[0][0];
    case "MultiPolygon":
      return coordinates[0][0][0];
    default:
      return coordinates;
  }
};

createReactPopup = (popupData) => {
    return ReactDOMServer.renderToString(<CompetitorPopup data={popupData} />);
};

processCompetitor = (competitor, counters, markers, geojson, layer) => {
  const coordinates = this.extractCoordinates(competitor.geometry);

  // Handle map markers/geojson
  if (coordinates) {
    if (layer) {
        const popupData = {
            Est_revenue: competitor.Est_revenue,
            ranking: competitor.ranking,
            lease: competitor.bl?.[1] * 15,
            locationValue: competitor.bl?.[0],
            Employee_cost: competitor.Employee_cost,
            footTraffic: competitor?.segmentation?.visitors
          }
      const marker = new mapboxgl.Marker()
        .setLngLat(coordinates)
        .setPopup(new mapboxgl.Popup().setHTML(this.createReactPopup(popupData)))
        .addTo(this.state.map);
      markers.push(marker);
    } else {
    
      geojson.push({
        type: "Feature",
        geometry: { type: "Point", coordinates },
        properties: {
          title: competitor.Name,
          footTraffic: competitor?.segmentation?.visitors,
          Est_revenue: competitor.Est_revenue,
          ranking: competitor.ranking,
          lease: competitor.bl?.[1],
          locationValue: competitor.bl?.[0],
          Employee_cost: competitor.Employee_cost
        }
      });
    }
  }

  // Process financial data
  if (competitor.Est_revenue) {
    counters.totals.Est_revenue += competitor.Est_revenue;
    counters.counts[0]++;
  }

  if (competitor.bl?.[1]) {
    counters.totals.bl_cost += Math.round(competitor.bl[1] * 15);
    counters.counts[2]++;
  }

  if (competitor.Employee_cost) {
    counters.totals.Employee_cost += competitor.Employee_cost;
    counters.counts[3]++;
  }

  // Process demographics
  const demo = competitor.demo;
  if (!demo) return;

  if (demo.pop) {
    counters.population += demo.pop;
    counters.counts[1]++;
  }

  if (demo.expense?.[0] > 0) {
    counters.expense += demo.expense[0];
    counters.counts[4]++;
  }

  if (demo.income > 0) {
    counters.income += demo.income;
    counters.counts[5]++;
  }

  // Process demographic arrays
  if (demo.degree) {
    demo.degree.forEach((deg, index) => {
      if (deg > 0) counters.demographics.degree[index] += deg;
    });
  }

  if (demo.gender) {
    counters.demographics.gender[0] += demo.gender.male;
    counters.demographics.gender[1] += demo.gender.female;
  }

  if (demo.age) {
    demo.age.forEach((ageGroup, index) => {
      counters.demographics.age[index] += ageGroup;
    });
  }

  if (demo.race) {
    const raceMapping = {
      "White": 0,
      "Black/African American": 1,
      "Hispanic/Latino": 2,
      "Asian": 3,
      "American Indian": 4
    };
    
    Object.entries(demo.race).forEach(([raceKey, value]) => {
      const index = raceMapping[raceKey];
      if (index !== undefined) {
        counters.demographics.race[index] += value;
      }
    });
  }
};

calculatePercentages = (arr) => {
  const total = arr.reduce((sum, val) => sum + val, 0);
  return total > 0 ? arr.map(val => Math.round((val / total) * 100)) : arr;
};

calculateAverageAndProject = (total, count, finalLocations, searchNumFn) => {
  if (count === 0) return { total: 0, average: 0 };
  
  const average = total / count;
  const remaining = parseInt(finalLocations) - count;
  const projectedTotal = searchNumFn(remaining, total, average);
  
  return { total: projectedTotal, average };
};

// Main refactored function
handleFullResponse = (res) => {
  const counters = this.initializeCounters();
  const markers = [];
  const geojson = [];
  const layer = res.competitor.length < 500;

  // Show initial position
  if (layer) {
    this.showposition(null, res.geometry);
  }

  // Process each competitor
  res.competitor.forEach(competitor => {
    this.processCompetitor(competitor, counters, markers, geojson, layer);
  });

  // Show final position for non-layer mode
  if (!layer) {
    this.showposition(geojson, res.geometry);
  }

  // Calculate demographics percentages
  const demographics = {
    age: this.calculatePercentages(counters.demographics.age),
    race: this.calculatePercentages(counters.demographics.race),
    gender: counters.demographics.gender[0] + counters.demographics.gender[1] > 0
      ? [
          counters.demographics.gender[0] / (counters.demographics.gender[0] + counters.demographics.gender[1]),
          counters.demographics.gender[1] / (counters.demographics.gender[0] + counters.demographics.gender[1])
        ]
      : [0, 0],
    degree: (() => {
      const degreeTotal = counters.demographics.degree.reduce((sum, deg) => sum + deg, 0);
      return degreeTotal > 0 
        ? counters.demographics.degree.map(deg => Math.round((deg / degreeTotal) * 100) / 100)
        : counters.demographics.degree;
    })()
  };

  // Calculate projections
  const finalLocations = res.brand.final_locations;
  
  const revenue = this.calculateAverageAndProject(
    counters.totals.Est_revenue, 
    counters.counts[0], 
    finalLocations, 
    this.search_num
  );

  const populationData = this.calculateAverageAndProject(
    counters.population, 
    counters.counts[1], 
    finalLocations, 
    this.search_num
  );

  const blCostData = this.calculateAverageAndProject(
    counters.totals.bl_cost, 
    counters.counts[2], 
    finalLocations, 
    this.search_num
  );

  const employeeCostData = this.calculateAverageAndProject(
    counters.totals.Employee_cost, 
    counters.counts[3], 
    finalLocations, 
    this.search_num
  );

  // Calculate final averages
  const avgExpense = counters.counts[4] > 0 ? Math.round(counters.expense / counters.counts[4]) : 0;
  const avgIncome = counters.counts[5] > 0 ? Math.round(counters.income / counters.counts[5]) : 0;

  // Update state
  this.setState({
    type: res.brand.type,
    markers,
    upgradereq: false,
    loading: false,
    race: demographics.race,
    age: demographics.age,
    brand: res.brand,
    search: res.search,
    gender: demographics.gender,
    social_data: res.brand.social_data,
    income: avgIncome,
    Employee_cost_avg: employeeCostData.average,
    expense: avgExpense,
    degree: demographics.degree,
    Employee_cost: employeeCostData.total,
    bl_cost: blCostData.total,
    bl_cost_avg: blCostData.average,
    competitor: res.competitor,
    num_population: counters.counts[1],
    Est_revenue: revenue.total,
    avg_revenue: revenue.average,
    population: populationData.total
  });
};
    
    handleSearchError = (error) => {
        console.log(error, 'response error');
        
        if (error.response) {
            const { status, data } = error.response;
            
            if (status === 401) {
                window.location.href = "/account";
            } else if (status === 400) {
                localStorage.removeItem("auth-token");
                window.location.href = '/login'
            } else if (data.Requests) {
                this.setState({errornumber: data.Requests, upgradereq: true});
            } else if (data === "login") {
                this.setState({register: true, registertype: false});
            } else if (data === "register") {
                this.setState({register: true, registertype: true});
            }
        }
    }

    componentDidMount() {
        let search = window.location.search;
        let params = new URLSearchParams(search);
        search = params.get('search');

        if (!this.state.map) {
            mapboxgl.accessToken = 'pk.eyJ1Ijoic25pa2FlaW4iLCJhIjoiY2s1eWNpcWxrMDJvbzNtcDdyb3puNTVrMCJ9.t-VFWsbpRo--tRSLgLa9ng';
            const map = new mapboxgl.Map({
                container: 'mapbox',
                style: 'mapbox://styles/mapbox/light-v10',
                center: [-95, 38.2],
                zoom: 3.5
            });
            console.log('map: ', map);
    
            map.scrollZoom.disable();
            map.addControl(new mapboxgl.NavigationControl());
            
            // Use callback to ensure state is updated before proceeding
            map.on('load', () => {
                    if(!drawtooltip){
                        console.log('this.state.drawtooltip: ', drawtooltip)
                        
                        const draw = new MapboxDraw({
                          displayControlsDefault: false,
                          controls: {
                          polygon: true,
                          trash: true
                          }
                          });
                          this.state.map.addControl(draw, 'bottom-right');
                          this.state.map.on('draw.create', this.customUpdateLocationArea);
                          this.state.map.on('draw.delete', this.customUpdateLocationArea);
                          this.state.map.on('draw.update', this.customUpdateLocationArea);
                          drawtooltip = true;
                          this.setState({ draw})

                          document.querySelector(".mapbox-gl-draw_trash").onclick =  this.customUpdateLocationArea
                    }
            })
            this.setState({ map }, () => {
                if(search){
                    this.searchvalue(search)
                    this.setState({search_competitor: search})
                }
            });

        }
    }

    customUpdateLocationArea = async (e) => {
        // console.log('customUpdateLocationArea called with event: ', e);
        
        // Handle different event types
        if (e.type === 'draw.create') {
            // Remove all previously drawn polygons except the current one
            const allFeatures = this.state.draw.getAll();
            console.log('All features before cleanup: ', allFeatures);
            
            // Keep only the most recently created feature
            if (allFeatures.features.length > 1) {
                // Get the ID of the newly created feature
                const newFeatureId = e.features[0].id;
                
                // Delete all features except the new one
                allFeatures.features.forEach(feature => {
                    if (feature.id !== newFeatureId) {
                        this.state.draw.delete(feature.id);
                    }
                });
            }
            
            // Process the new polygon
            if (e.features && e.features.length > 0) {
                let geo = e.features[0].geometry;
                console.log('New polygon geometry: ', geo);
                
                // Call search with the new geometry
                await this.searchvalue(this.state.search_competitor, null, geo);
            }
        }
        else if (e.type === 'draw.delete') {
            // Handle polygon deletion
            console.log('Polygon deleted');
            
            // If no polygons remain, you might want to clear the search or reset to default
            const remainingFeatures = this.state.draw.getAll();
            if (remainingFeatures.features.length === 0) {
                console.log('No polygons remaining');
                // Optionally clear search results or reset to default search
                await this.searchvalue(this.state.search_competitor, null, null);
            }
        }
        else if (e.type === 'draw.update') {
            // Handle polygon update (when user modifies existing polygon)
            if (e.features && e.features.length > 0) {
                let geo = e.features[0].geometry;
                console.log('Updated polygon geometry: ', geo);
                
                // Call search with the updated geometry
                await this.searchvalue(this.state.search_competitor, null, geo);
            }
        }
        else if (e.type === 'click' && e.target.classList.contains('mapbox-gl-draw_trash')) {
            // Handle trash button click
            console.log('Trash button clicked');
            // The draw.delete event will be triggered automatically
        }
    }

    componentWillMount() {

        let token = localStorage.getItem("auth-token");
        if(!token){
            this.setState({register: true, registertype: true})
        }


    }
    numberWithCommas(x) {
        if(!x) return "No Data"
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    closeregisterer = (freetier) => {
        console.log(freetier)
        if(freetier == null){
            this.setState({register: false})

        }
        else{
            this.setState({freetier: freetier.freetier, register: false})
            if(this.state.search_competitor) this.searchvalue(this.state.search_competitor)

        }
    }
    login = () => this.setState({register: true, registertype: false})
    register = () => this.setState({register: true, registertype: true})
    changeregister = () => this.setState({registertype: !this.state.registertype})
    upgradepage = () => {
        if(this.state.freetier) return window.location.href = "https://mapchise.com/contact/"
        window.location.href = "/account"
    }
    locationsearch = (location) =>{
        if (this.state.map.getSource('region')){
            this.state.map.removeLayer('region')
            this.state.map.removeSource('region');
        }
        this.state.map.flyTo({
            center: [-95, 38.2],
            zoom: 3.5
            });
        this.searchvalue(this.state.search_competitor, location)
    }

    focusLocation = (location) => {
        const geometry = location['geometry']
        const coordinates = this.extractCoordinates(geometry)
        // console.log('location: ', location)
        this.state.map.flyTo({
            center: coordinates,
            zoom: 15
            });
    }
    getCurrentLocationsVal = () => {
  
    }

    exportValues = async () => {
        let token = localStorage.getItem("auth-token");
        const locationData = this.state.competitor.map((location) => ({address: location.add, income: location.demo?.income, population: location.demo?.pop, spendingAverage: location.demo?.expense?.[0], visitors: location.segmentation?.visitors}))
        const export_excel = await axios.post('/gettheurl/competitor-export-locations', {locationData}, {
            responseType: 'blob', headers:{ "auth-token": token}
        })            

        
        const url = window.URL.createObjectURL(new Blob([export_excel.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download =  `Mapchise - ${this.state.search}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }

    handleAccordionChange = (panel) => {
        this.setState({
            expandedPanel: this.state.expandedPanel === panel ? false : panel
        });
    };

    handleRowToggle = (index) => {
        this.setState(prevState => ({
            expandedRows: {
                ...prevState.expandedRows,
                [index]: !prevState.expandedRows[index]
            }
        }));
    };

    formatPrice = (price) => {
        if (!price) return 'N/A';
        return typeof price === 'number' ? `$${price.toFixed(2)}` : price;
    };

    render() {
        let searchvalue =this.state.search !== "" && this.state.search;
        return (
          <div id = "Competitor-research-main">
                {this.state.upgradereq? <div className="Competitor-register-total">
                 <div className="Competitor-register-main">
                 <div className="Competitor-upgrade-total">
                 <img src={maptize} className="Competitor-research-menu-logo2"/>
                 <div className="Competitor-search-header2">Upgrade to Continue</div>
                 <div className="Competitor-upgrade-value">You have reached your accounts search limit: {this.state.errornumber} </div>
                 <div className="Competitor-research-started2" onClick={this.upgradepage}>Upgrade</div>
                 </div>
                 </div>
             </div>
             :null}
            {/* Removed Competitor_sidebar - replaced with CompetitorSearchBar below */}
              <Competitor_research_menu freetier={this.state.freetier} register={this.register} login={this.login} section_hide={true} />
              {/* {this.state.register? <Competitor_register changeregister={this.changeregister} type={this.state.registertype} closeregisterer={this.closeregisterer}/>:null} */}
                <div className="Competitor_search-top">
                <div className={(searchvalue)?"Competitor_reasearch-total2": "Competitor_research-total2-none"}>
                <div className="Competitor_reasearch-total3">
                <div className='mr-10'><Search className='main-filter-image' />
                <input className="prospect-searchbar w-780-350" placeholder="Enter a Retail/Restaurant Brand" value={this.state.search_competitor}  onChange={this.competitor_search}></input>
                </div>
                {(this.state.search_result_show)?
                <OutsideClickHandler onOutsideClick={() => this.setState({search_result_show: false})} >
                <div className="Competitor-result-total">
                    {
                        this.state.searched.map((search) => {
                        return <div key={search._id} className="Competitor-result-each" onClick={() =>this.searchvalue(search.Name)}>
                            <div className="Competitor-result-eachpicture">
                                {(search.Image)?
                                <img src={search.Image} onError={(e)=>{e.target.onerror = null; e.target.src="https://i.ibb.co/8NYd9pw/white-background.png"}} className="Competitor-result-image"/>: <div  className="Competitor-result-image"></div>
                                }
                                </div>
                            <div className="Competitor-result-eachname">{search.Name}</div>
                            <div className="Competitor-result-count"><div className="Competitor-result-count-name">Est. Locations</div>
                            <div className="Competitor-result-count-value">{search.final_locations? this.numberWithCommas(search.final_locations): this.numberWithCommas(search.Total)}</div></div>
                        </div>
                        })
                    }
                </div></OutsideClickHandler>:null}
                <div className='mt-10 color-white'>{this.state.error}</div>

                </div>
                </div>
                </div>
                {(this.state.loading) && <div className="Competitor-loading">Loading <div className="Competitor-spinner">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                    </div>
                </div>
                }
                 {/* {(searchvalue)?<div> */}

                <Competitor_brand search={this.state.search} brand={this.state.brand}/>
                
                {/* New MUI Search Bar */}
                {(searchvalue) && <CompetitorSearchBar 
                    exportValues={this.exportValues} 
                    customBoundary={this.state.customBoundary} 
                    locationsearch={this.locationsearch}
                />}
                
                {/* <Competitor_financials business_data={this.state.business_data} Employee_cost={this.state.Employee_cost} Employee_cost_avg={this.state.Employee_cost_avg} bl_cost = {this.state.bl_cost} bl_cost_avg={this.state.bl_cost_avg} freetier={this.state.freetier} avg_revenue={this.state.avg_revenue} Est_revenue={this.state.Est_revenue}/> */}
            
                <CompetitorTopPerformers topLineClass={'p-25-15-3'} focusLocation={this.focusLocation} freetier={this.props.freetier} competitor={this.state.competitor}/>
                
                <div className="p-25-15-3">
                    <Box sx={{ width: '100%' }}>
                        
                        {/* Top Market Segmentations Accordion */}
                        <Accordion 
                            expanded={this.state.expandedPanel === 'panel1'} 
                            onChange={() => this.handleAccordionChange('panel1')}
                            sx={{ mb: 2, boxShadow: 'none', border: '1px solid #E9EAEB' }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{  minHeight: '56px' }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>Top Market Segmentations</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ p: 0 }}>
                                <CompetitorMarketSegmentation topLineClass={""} focusLocation={this.focusLocation} freetier={this.props.freetier} competitor={this.state.competitor}/>
                            </AccordionDetails>
                        </Accordion>

                        {/* Product Overview Accordion */}
                        {this.state.products && this.state.products.length > 0 && (
                            <Accordion 
                                expanded={this.state.expandedPanel === 'panel2'} 
                                onChange={() => this.handleAccordionChange('panel2')}
                                sx={{ mb: 2, boxShadow: 'none', border: '1px solid #E9EAEB' }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{ minHeight: '56px' }}
                                >
                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>Product Overview</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 0 }}>
                                    <CompetitorProductOverview topLineClass={""} products={this.state.products} website={this.state.website}/>
                                </AccordionDetails>
                            </Accordion>
                        )}

                        {/* Deals Overview Accordion */}
                        {this.state.deals && this.state.deals.length > 0 && (
                            <Accordion 
                                expanded={this.state.expandedPanel === 'panel3'} 
                                onChange={() => this.handleAccordionChange('panel3')}
                                sx={{ mb: 2, boxShadow: 'none', border: '1px solid #E9EAEB' }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{ minHeight: '56px' }}
                                >
                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>Deals & Promotions</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 0 }}>
                                    <CompetitorDealsOverview topLineClass={""} deals={this.state.deals} website={this.state.website}/>
                                </AccordionDetails>
                            </Accordion>
                        )}

                        {/* Demographic Information Accordion */}
                        <Accordion 
                            expanded={this.state.expandedPanel === 'panel4'} 
                            onChange={() => this.handleAccordionChange('panel4')}
                            sx={{ mb: 2, boxShadow: 'none', border: '1px solid #E9EAEB' }}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                sx={{ minHeight: '56px' }}
                            >
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>Demographic Information</Typography>
                            </AccordionSummary>
                            <AccordionDetails sx={{ p: 0 }}>
                                <Competitor_demographic freetier={this.state.freetier} income={this.state.income} expense={this.state.expense} population={this.state.population}/>
                                {this.state.brandLocal ?
                                    <Competitor_demographic_local exportInd state={{zoom: 0, arrangement:[0,1,2,3,4,5,6,7,8,9,10,11,12]}} business_data={this.state.business_data.map((e) => e.data_circle)} industry_hidemore={()=> {}} dem_showmore={()=> {}} unsetarrangement={()=> {}} setarrangement={()=> {}}/>
                                :
                                    <Competitor_demographic_graphs type={this.state.type} freetier={this.state.freetier} age={this.state.age} race={this.state.race}  degree={this.state.degree} gender={this.state.gender}/>
                                }
                            </AccordionDetails>
                        </Accordion>
                    </Box>
                </div>

                {/* <Competitor_social freetier={this.state.freetier} social_data={this.state.social_data}/> */}
                {/* </div>:null} */}
              </div>
    )}
}